import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Observable } from 'rxjs';
import { MyAuthService } from 'src/app/core/services/auth.service';
import { TutorialAnchorDirective } from 'src/app/core/tutorial/tutorial-anchor.directive';

@Component({
  selector: 'app-navigation-rail',
  standalone: true,
  imports: [CommonModule, RouterModule, MatButtonModule, MatIconModule, TutorialAnchorDirective],
  templateUrl: './navigation-rail.component.html',
  styleUrls: ['./navigation-rail.component.scss']
})
export class NavigationRailComponent {
  @Input() active: 'workspace' | 'cases' | 'account' | 'admin' | 'accounts' = 'workspace';
  @Output() searchRequested = new EventEmitter<void>();
  @Output() workspaceRequested = new EventEmitter<void>();

  private readonly router = inject(Router);
  private readonly auth = inject(AuthService);
  private readonly myAuthService = inject(MyAuthService);

  readonly user$ = this.auth.user$;
  readonly isAdmin$: Observable<boolean> = this.myAuthService.isAdmin();
  readonly isSales$: Observable<boolean> = this.myAuthService.isSales();
  adminMenuOpen = false;

  openSearch(): void {
    if (this.active === 'workspace') {
      this.searchRequested.emit();
      return;
    }

    this.router.navigate(['/'], { queryParams: { intent: 'vessel-search' } });
  }

  goToWorkspace(): void {
    if (this.active === 'workspace') {
      this.workspaceRequested.emit();
      return;
    }

    this.router.navigate(['/']);
  }

  goToReports(): void {
    this.router.navigate(['/reports']);
  }

  toggleAdministration(): void { this.adminMenuOpen = !this.adminMenuOpen; }
  closeAdministration(): void { this.adminMenuOpen = false; }

  accountInitials(user: { given_name?: string; family_name?: string; email?: string } | null): string {
    const initials = [user?.given_name, user?.family_name]
      .filter(Boolean)
      .map(name => name![0])
      .join('')
      .toUpperCase();

    return initials || (user?.email || 'AC').slice(0, 2).toUpperCase();
  }
}
